


























































































import { VueConstructor } from 'vue';
import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { Spacing } from '@front-app/components/constants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {
		FontAwesomeIcon,
	},
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			default: 'div',
		},
		isSelected: Boolean,
		isHoverable: Boolean,
		isClickable: Boolean,
		disableShadow: Boolean,
		a11yClickCardText: {
			type: String,
			default: '',
		},
		isMergedList: Boolean,
		isUnread: Boolean,
		useUnreadDot: Boolean,
		hasError: Boolean,
		hasWarning: Boolean,
		hasSuccess: Boolean,
		unreadDotAria: {
			type: String,
			required: false,
			default: '',
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.LOOSE,
		},
	},
	setup(props, ctx) {
		onMounted(() => {
			ctx.emit('mounted');
		});
		const noticeIcon = computed(() => {
			if (props.hasError) {
				return 'times-circle';
			}
			if (props.hasWarning) {
				return 'exclamation-triangle';
			}
			if (props.hasSuccess) {
				return 'check-circle';
			}
			return '';
		});
		const hasA11yFocus = ref(false);
		watch(() => [props.isClickable, props.a11yClickCardText], (isClickable, a11yClickCardText) => {
			if (isClickable && !a11yClickCardText) {
				// eslint-disable-next-line no-console
				console.error('Prop vaidation failed. If a card is clickable, it must have accessible text.');
			}
		}, { immediate: true });
		const onA11yFocus = () => {
			hasA11yFocus.value = true;
		};
		const onA11yBlur = () => {
			hasA11yFocus.value = false;
		};
		const hasSlotChildren = computed(() => {
			const defaultSlot = ctx.slots.default;
			return defaultSlot && defaultSlot().length > 0;
		});
		return {
			hasSlotChildren,
			hasA11yFocus,
			onA11yFocus,
			onA11yBlur,
			Spacing,
			noticeIcon,
		};
	},
});
